<template>
    <Head title="Viewing Manufacturer" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Viewing Manufacturer - {{ manufacturer.name }}
            </h2>
        </template>
        <BreadCrumbs :items="items"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <h2 class="mx-5 text-gray-700 font-semibold text-2xl tracking-wide mb-2">Models for {{ manufacturer.name }}</h2>
            <div class="px-6 pt-4 pb-2">
                <div class="overflow-x-auto">
                    <div class="inline-block min-w-full overflow-hidden">
                        <table class="min-w-full leading-normal">
                            <thead>
                                <tr>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-left text-sm tracking-wider hidden lg:table-cell">ID</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-left text-sm tracking-wider">Name</th>
                                    <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-left text-sm tracking-wider">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="models.data.length" v-for="model of models.data">
                                    <td class="px-5 py-5 border-l-2 border-b border-grey-200 bg-white text-sm md:text-base hidden lg:table-cell">
                                        {{ model.id }}
                                    </td>
                                    <td class="px-5 py-5 border-l-2 lg:border-l-0 border-b border-grey-200 bg-white text-sm md:text-base">
                                        {{ model.name }}
                                    </td>
                                    <td class="px-5 py-5 border-r-2 border-b border-grey-200 bg-white text-sm md:text-base text-center lg:text-right">
                                        <admin-link class="bg-grey-100 text-dark" target="_blank"
                                                    :href="route('manufacturers.models.show', [manufacturer, model])">
                                            View
                                        </admin-link>
                                        <admin-link :href="'/admin/models/' + model.id + '/edit'">Edit</admin-link>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td class="py-6 bg-red" colspan="3" align="center">
                                        <p class="text-white font-bold">No products found</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <admin-pagination class="mt-6" :links="models.links" />
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue'
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import AdminSearchForm from "@/Components/Admin/Forms/AdminSearchForm";
import AdminLink from "@/Components/Admin/AdminLink";
import AdminPagination from "@/Components/Admin/AdminPagination";
export default {
    name: "View",
    components: {
      AdminLink,
      AdminPagination,
      AdminSearchForm,
      Head,
      BreadCrumbs,
      BreezeAuthenticatedLayout
    },
    props: {
        term: String,
        models: Object,
        manufacturer: Object
    },
    data: function()
    {
        return {
            items: [
                { title: 'Manufacturers', path: '/admin/manufacturers' },
            ],
            form: useForm({
                search: this.term
            })
        }
    },
    mounted() {
        var valueToPush = { };
        valueToPush.title = this.manufacturer.name;
        valueToPush.path = "/admin/manufacturers/"+this.manufacturer.id+"";

        this.items.push(valueToPush);
    }
}
</script>

<style scoped>

</style>
